import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/*
  GET /tickets/ciclo?sprints=8
  Retorna tempo médio gasto em cada etapa do fluxo de trabalho,
  calculado a partir das transições de status (journals do Redmine)
  combinado com os registros de buffer (gp_ticket_buffer_log).

  Resposta esperada:
  {
    "etapas": [
      { "chave": "aguardando_distribuicao", "label": "Aguardando Distribuição",
        "media": 1.3, "mediana": 0.8, "min": 0.1, "max": 8.2, "tickets": 156,
        "cor": "#60a5fa" },
      ...
    ],
    "por_tipo": {
      "Bug": [{ "chave": "...", "media": 1.1, "mediana": 0.7 }],
      "Funcionalidade": [...]
    },
    "total_medio": 14.5,
    "periodo": { "sprints": 8, "de": "2025-01-01", "ate": "2025-05-24" }
  }
*/
export async function getCicloVida(sprints = 8) {
  const { data } = await api.get(`/tickets/ciclo?sprints=${sprints}`);
  return data;
}
